module.exports = __webpack_public_path__ + "assets/img/1.a1a25962.png";